import { useLoadingStore } from '@/stores/loading'
import { useSettingsStore } from '@/stores/settings'
import { useServiceTemplatesStore } from '@/stores/serviceTemplates'
import { useQueryParams } from '@/router/useQueryParams'

export function useRouter() {
  const preloadSettingPage = async (to) => {
    const loadingStore = useLoadingStore()
    await loadingStore.toggleLoading({ set: true })

    await useSettingsStore().fetchGlobalSettings()
    await useServiceTemplatesStore().fetchServiceTemplatesSEO()
    useQueryParams(to).extractSearchParams()
  }

  return {
    preloadSettingPage
  }
}
